import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  storeImage: {
    width: 137,
    height: 40,
  },
});

export default styles;
